import { render, staticRenderFns } from "./productSuggest.vue?vue&type=template&id=6715efc7&"
import script from "./productSuggest.vue?vue&type=script&lang=ts&"
export * from "./productSuggest.vue?vue&type=script&lang=ts&"
import style0 from "./productSuggest.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports